import React, { useState, useEffect, useContext  } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "component/AuthContext";

import Logo_GH from "assets/images/logo_GH.png";

const Login = () => {
  useEffect(() => {
    document.title = "Green Hill Kemuning | Login";
    localStorage.removeItem("token");
  }, []);

  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Reset error sebelum request

    const dataLogin = {
      user_name: username, 
      user_password: password,
    };
  
    try {
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API}/login`,
        data: dataLogin,
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      if (response.status !== 200) {
        setError(response.data.msg_desc || "Username atau password salah.");
        return;
      }

      const token = response.data.token;
      const user = response.data.user;
      const access = response.data.access;
      console.log(access)
  
      login(token, user, access);
      navigate("/calendar");
  
    } catch (error) {
      console.error("Login error:", error);
      setError("Terjadi kesalahan. Coba lagi.");
    }
  };
  

  return (
    <section className="vh-100" style={{ backgroundColor: "#508bfc" }}>
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-2-strong" style={{ borderRadius: "1rem" }}>
              <div className="card-body p-5">
                <div className="mb-3 d-flex justify-content-center align-items-center">
                  <img src={Logo_GH} height="100" alt="logo-gh" />
                </div>
                {/* <h3 className="mb-5 text-center">Sign in</h3> */}
                {error && <p style={{ color: "red", textAlign:"center" }}>{error}</p>}

                <form onSubmit={handleLogin}>
                  <div className="form-outline mb-4">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={username}
                      onChange={(e) => setUsername(e.target.value.toLocaleUpperCase())}
                      required
                    />
                  </div>

                  <div className="form-outline mb-4">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  <button className="btn btn-primary btn-lg btn-block  d-grid w-100" type="submit">
                    Login
                  </button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
